module.exports = __webpack_public_path__ + "img/img4.6f013670.png";